import { useContext } from "react";
import { LanguageContext } from "../context/language.context";

export const useLanguageContext = () => {
  const context = useContext(LanguageContext);
  return context;
};
